import { BaseCRMAdapter } from "../BaseCRMAdapter";
import { Get_Countries, Get_States } from "@/services/graph-ql/queries";
import { Get_Business_Categories, Get_Industries } from "@/modules/crm/automation/graphql-queries";
import { Get_System_Users } from "@/modules/crm/leads/graphql-queries/general-queries";
import { Get_TimeZones } from "@/modules/crm/leads/graphql-queries/timezone";
import { Get_Companies } from "@/modules/crm/leads/graphql-queries";

export class CRMLookupsAdapter extends BaseCRMAdapter {
  async getCountries() {
    return this._query({ query: Get_Countries });
  }

  async getStatesProvinces() {
    return this._query({ query: Get_States });
  }

  async getIndustries() {
    return this._query({ query: Get_Industries });
  }

  async getBusinessCategories() {
    return this._query({ query: Get_Business_Categories, skip: 0, take: 50 });
  }

  async getTimezones() {
    return this._query({ query: Get_TimeZones });
  }

  async getSystemUsers() {
    return this._query({ query: Get_System_Users });
  }

  async getUserCompanies(userEmail) {
    return this._query({ query: Get_Companies, userEmail });
  }
}
